import React from 'react';
import { connect } from 'react-redux';
import MagnetConfigPopoverComponent from 'components/annotation-page/standard-workspace/controls-side-bar/magnet-config-popover';
import { Canvas } from 'cvat-canvas/src/typescript/canvas';
import { CombinedState, MagnetModeType } from '../../../../reducers';

interface State {

}

interface StateToProps {
    canvasInstance: Canvas
}

interface DispatchToProps {

}

type Props = StateToProps & DispatchToProps;

function mapStateToProps(state: CombinedState): StateToProps {
    const {
        annotation: {
            canvas: { instance: canvasInstance },
        },
    } = state;

    return {
        canvasInstance: canvasInstance as Canvas,
    };
}

function mapDispatchToProps(): DispatchToProps {
    return {};
}

class MagnetConfigPopoverContainer extends React.PureComponent<Props, State> {
    private onChangeMagnetConfig = (checkedValues: MagnetModeType[]): void => {
        const { canvasInstance } = this.props;
        const magnetConfig = {
            snapPointEnabled: checkedValues.includes(MagnetModeType.POINT),
            snapLineByAnnotationVertexEnabled: checkedValues.includes(MagnetModeType.LINE),
            edgeMagnetEnabled: checkedValues.includes(MagnetModeType.EDGE),
        };

        canvasInstance.magnetConfig(magnetConfig);
    };

    private defaultMagnetConfig = (canvasInstance: Canvas): MagnetModeType[] => {
        const magnetConfig = canvasInstance.magnetConfig();
        const defaultMagnetConfig = [];
        if (magnetConfig.edgeMagnetEnabled) {
            defaultMagnetConfig.push(MagnetModeType.EDGE);
        }
        if (magnetConfig.snapLineByAnnotationVertexEnabled) {
            defaultMagnetConfig.push(MagnetModeType.LINE);
        }
        if (magnetConfig.snapPointEnabled) {
            defaultMagnetConfig.push(MagnetModeType.POINT);
        }

        return defaultMagnetConfig;
    };

    public render(): JSX.Element {
        const { canvasInstance } = this.props;

        return (
            <MagnetConfigPopoverComponent
                onChangeMagnetConfig={this.onChangeMagnetConfig}
                defaultMagnetConfig={this.defaultMagnetConfig(canvasInstance)}
            />
        );
    }
}

export default connect<StateToProps, DispatchToProps, {}, CombinedState>(
    mapStateToProps,
    mapDispatchToProps,
)(MagnetConfigPopoverContainer);
